module.exports = __webpack_public_path__ + "videos/special-event_cn.fe76818.mp4";